import { Directive, ElementRef, EventEmitter, Input, OnDestroy, AfterViewInit, Output } from "@angular/core";

@Directive({
  standalone: true,
  selector: "[appInfiniteScrollSentinel]",
})
export class InfiniteScrollSentinelDirective implements AfterViewInit, OnDestroy {
  @Input() scrollContainer: HTMLElement | undefined;
  @Output() nearBottom = new EventEmitter<void>();

  private observer: IntersectionObserver | undefined;

  constructor(private elementHost: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.nearBottom.emit();
        }
      },
      { root: this.scrollContainer ?? null, rootMargin: "200px" }
    );
    this.observer.observe(this.elementHost.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
